import React from "react";
import { Palette, Type } from "lucide-react";
import { cn } from "../../lib/utils";
import Button from "../ui/Button";
import Card from "../ui/Card";

const ThemePanel = ({ previewSettings, onSettingsChange }) => {
  const handleChange = (key, value) => {
    onSettingsChange({ [key]: value });
  };

  return (
    <Card className="p-6 space-y-6">
      <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
        <Palette className="w-5 h-5" />
        Customize Appearance
      </h3>

      {/* Theme Selector */}
      <div>
        <label className="text-sm font-medium text-zinc-300 mb-2 block">
          Theme
        </label>
        <div className="grid grid-cols-3 gap-2">
          {["light", "dark", "custom"].map((theme) => (
            <button
              key={theme}
              onClick={() => handleChange("theme", theme)}
              className={cn(
                "px-3 py-2 rounded-lg text-sm font-medium transition-all",
                previewSettings.theme === theme
                  ? "bg-blue-600 text-white"
                  : "bg-zinc-800 text-zinc-300 hover:bg-zinc-700"
              )}
            >
              {theme.charAt(0).toUpperCase() + theme.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {/* Custom Colors (only show if custom theme) */}
      {previewSettings.theme === "custom" && (
        <>
          <div>
            <label className="text-sm font-medium text-zinc-300 mb-2 block">
              Card Background Color
            </label>
            <div className="flex items-center gap-3">
              <input
                type="color"
                value={previewSettings.cardBackgroundColor || previewSettings.backgroundColor || "#000000"}
                onChange={(e) => handleChange("cardBackgroundColor", e.target.value)}
                className="w-12 h-12 rounded cursor-pointer"
              />
              <input
                type="text"
                value={previewSettings.cardBackgroundColor || previewSettings.backgroundColor || "#000000"}
                onChange={(e) => handleChange("cardBackgroundColor", e.target.value)}
                className="flex-1 px-3 py-2 rounded-md border border-zinc-700 bg-zinc-900 text-white text-sm"
                placeholder="#000000"
              />
            </div>
            <p className="text-xs text-zinc-500 mt-1">This changes only the tweet card background</p>
          </div>

          <div>
            <label className="text-sm font-medium text-zinc-300 mb-2 block">
              Text Color
            </label>
            <div className="flex items-center gap-3">
              <input
                type="color"
                value={previewSettings.textColor || "#ffffff"}
                onChange={(e) => handleChange("textColor", e.target.value)}
                className="w-12 h-12 rounded cursor-pointer"
              />
              <input
                type="text"
                value={previewSettings.textColor || "#ffffff"}
                onChange={(e) => handleChange("textColor", e.target.value)}
                className="flex-1 px-3 py-2 rounded-md border border-zinc-700 bg-zinc-900 text-white text-sm"
                placeholder="#ffffff"
              />
            </div>
          </div>

        </>
      )}

      {/* Typography */}
      <div>
        <label className="text-sm font-medium text-zinc-300 mb-2 block flex items-center gap-2">
          <Type className="w-4 h-4" />
          Font Size
        </label>
        <div className="flex items-center gap-3">
          <input
            type="range"
            min="12"
            max="24"
            value={previewSettings.fontSize || 16}
            onChange={(e) =>
              handleChange("fontSize", parseInt(e.target.value))
            }
            className="flex-1"
          />
          <span className="text-sm text-zinc-400 w-12 text-right">
            {previewSettings.fontSize || 16}px
          </span>
        </div>
      </div>

      {/* Font Family */}
      <div>
        <label className="text-sm font-medium text-zinc-300 mb-2 block">
          Font Family
        </label>
        <select
          value={previewSettings.fontFamily || "Twitter"}
          onChange={(e) => handleChange("fontFamily", e.target.value)}
          className="w-full px-3 py-2 rounded-md border border-zinc-700 bg-zinc-900 text-white text-sm"
        >
          <option value="Twitter">Twitter (System)</option>
          <option value="Arial">Arial</option>
          <option value="Helvetica">Helvetica</option>
          <option value="Georgia">Georgia</option>
          <option value="Times New Roman">Times New Roman</option>
          <option value="Courier New">Courier New</option>
        </select>
      </div>

    </Card>
  );
};

export default ThemePanel;

